import { IconInfoCircle } from '@tabler/icons-react'

import { theme } from '@/shared/styles/theme'
import { Callout } from '@/shared/ui/Callout/index'
import { FormDescription } from '@/shared/ui/Form/FormDescription'
import { ExternalLink } from '@/shared/ui/Link'
import { Text, Title } from '@/shared/ui/Typography'

import {
  SupportChannelItem,
  SupportChannelList,
} from '@/modules/contato/components/ContactSupportInfo/styles'

const SUPPORT_LINKS = {
  whatsapp:
    'https://api.whatsapp.com/send/?phone=551141180488&text&type=phone_number&app_absent=0',
  serviceChannelsGuide:
    'https://faq.flashapp.com.br/kb/guide/pt-BR/fale-com-a-gente-horarios-e-canais-de-atendimento-PcTAZfm4Pc/Steps/4383969',
  faqHome: 'https://faq.flashapp.com.br/',
} as const

const externalLinkSecurityProps = {
  target: '_blank',
  rel: 'noopener noreferrer',
} as const

export function ContactSupportInfo() {
  return (
    <>
      <FormDescription>
        <Title as="h1" size="headline7">
          Fale conosco - Formulário de atendimento | Flash
        </Title>
        <Text size="body3">
          Para facilitar seu atendimento, seja você pessoa administradora ou
          colaboradora, escolha o canal de suporte que preferir:
        </Text>
        <SupportChannelList>
          <SupportChannelItem>
            Fale com nosso time pelo WhatsApp:{' '}
            <ExternalLink
              href={SUPPORT_LINKS.whatsapp}
              {...externalLinkSecurityProps}
            >
              (11) 4118-0488
            </ExternalLink>
          </SupportChannelItem>
          <SupportChannelItem>
            Consulte nossos horários e canais de atendimento:{' '}
            <ExternalLink
              href={SUPPORT_LINKS.serviceChannelsGuide}
              {...externalLinkSecurityProps}
            >
              Clicando aqui.
            </ExternalLink>
          </SupportChannelItem>
        </SupportChannelList>
        <Text size="body3">
          Se preferir, também é possível registrar sua solicitação pelo
          formulário abaixo.
        </Text>
      </FormDescription>

      <Callout
        icon={
          <IconInfoCircle
            size={40}
            stroke={1.5}
            color={theme.colors.info40.value}
          />
        }
      >
        <Text size="body3">
          Consulte a{' '}
          <ExternalLink
            href={SUPPORT_LINKS.faqHome}
            variant="info"
            {...externalLinkSecurityProps}
          >
            FAQ — Central de Ajuda da Flash
          </ExternalLink>{' '}
          para verificar as respostas das dúvidas mais frequentes.
        </Text>
      </Callout>
    </>
  )
}
